module.exports = __webpack_public_path__ + "static/media/teaser-5g-faktencheck.7a0ad5b9.jpg";